var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_53_207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.5438 60.2666L39.8813 65.9763",
    stroke: "#023527",
    strokeOpacity: 0.4,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.976 68.8814L49.1652 81.5599L50.4331 78.841C51.8277 75.8502 50.5217 72.2621 47.5309 70.8674L31.2174 63.2603C28.2266 61.8657 24.6385 63.1716 23.2438 66.1625L21.976 68.8814V68.8814Z",
    stroke: "#023527",
    strokeOpacity: 0.4,
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.257 67.6135L51.8841 82.8278",
    stroke: "#023527",
    strokeOpacity: 0.4,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7699 58.717C32.2476 53.8104 27.7058 41.3318 32.6124 30.8096L36.4159 22.6528C39.2179 16.644 46.3542 14.0466 52.3631 16.8485L68.6766 24.4556C74.6854 27.2576 77.2828 34.3939 74.4809 40.4028L70.6773 48.5595C65.7707 59.0818 53.2921 63.6236 42.7699 58.717Z",
    stroke: "#023527",
    strokeOpacity: 0.4,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5305 38.6107C28.7956 37.0073 27.5589 34.9742 26.8044 32.901C25.6252 29.041 25.5153 25.0176 27.2903 21.2111C29.0653 17.4046 33.4507 15.8085 37.2572 17.5835L39.0245 18.4076C37.8975 19.4047 36.979 20.6646 36.307 22.1056L32.5035 30.2624C31.2356 32.9813 30.6148 35.8033 30.5305 38.6107Z",
    stroke: "#023527",
    strokeOpacity: 0.4,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0396 55.1687C68.3831 55.467 70.7354 55.1075 72.8086 54.3529C76.5234 52.7751 79.6762 50.2731 81.4512 46.4666C83.2262 42.6601 81.63 38.2747 77.8235 36.4997L76.0562 35.6756C76.0168 37.1798 75.6421 38.6933 74.9701 40.1343L71.1666 48.2911C69.8987 51.01 68.136 53.2995 66.0396 55.1687Z",
    stroke: "#023527",
    strokeOpacity: 0.4,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_53_207"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white",
    transform: "translate(30.4285) rotate(25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCup);
export default __webpack_public_path__ + "static/media/cup.41a68e84a90f84405a2f62934175c917.svg";
export { ForwardRef as ReactComponent };